import { render, staticRenderFns } from "./SignatureElement.vue?vue&type=template&id=fac0a9ac&scoped=true&"
import script from "./SignatureElement.vue?vue&type=script&lang=ts&"
export * from "./SignatureElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac0a9ac",
  null
  
)

export default component.exports